import React from "react";
import styles from './Header-layout.module.scss';

const HeaderLayout = (props) => {
    return (
      <div className={styles.container}>
        <div className={styles.row}>
          {props.children}
        </div>
      </div>
    );
};

export default HeaderLayout;